// Tabs: Pending review / Approved / Unmatched.
// Part of the Review page (components/Review.jsx). Split out 2026-10-14.

export default function ReviewTabs({ appTotal, me, pending, setSelected, setTab, tab, unmatched }) {
  return (
    <>
      <div className="tabs" style={{ display: 'flex', alignItems: 'center' }}>
        <button className={tab === 'pending'  ? 'tab active' : 'tab'} onClick={() => { setTab('pending');  setSelected(new Set()); }}>
          Pending review <strong style={{ color: '#d97706' }}>({pending.counts.pending.toLocaleString()})</strong>
        </button>
        <button className={tab === 'approved' ? 'tab active' : 'tab'} onClick={() => { setTab('approved'); setSelected(new Set()); }}>
          Approved <strong style={{ color: '#16a34a' }}>({appTotal.toLocaleString()})</strong>
        </button>
        {me && me.isAdmin && (
          <button
            className={tab === 'unmatched' ? 'tab active' : 'tab'}
            onClick={() => { setTab('unmatched'); setSelected(new Set()); }}
            style={{ marginLeft: 'auto', fontSize: '0.8em', opacity: 0.7, padding: '4px 10px' }}
            title="Pre-Jun-15 sheet rows with no matching Approved row — diagnostic only">
            unmatched ({pending.counts.unmatchedHistorical.toLocaleString()})
          </button>
        )}
      </div>
    </>
  );
}
